import React from "react";
import "./SectionHeaderStyle.scss";
import WizardSteps from "../WizardSteps/WizardSteps";
import TopNavBar from "../../TopNavBar/TopNavBar";


const SectionHeader = ({ title, stepNo, totalStep, failedStep , onStepClick, showHeader = true }) => {
  return (
    <>
      <TopNavBar />
       {showHeader && (
      <div className="container section-header">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2 className="section-text">{title}</h2>
          </div>
          {stepNo && <div className="col-md-6 ">
             <WizardSteps
                  stepNo={stepNo}
                  totalStep={totalStep}
                  failedStep={failedStep}
                  onStepClick={onStepClick}
                />
          </div>}
        </div>
      </div>
       )}
    </>
  );
};

export default SectionHeader;